// This file will not have any imported local module
// as it is solely responsible to help hardwiredlogic.js
import _ from "lodash";
import underscore, { initial } from "underscore";

export const addSequenceElementToArray = (array) => {
  if (_.isEmpty(array)) return array;

  let max = Math.max(...array);

  let next = max + 1;

  let newArray = [...array, next];

  return newArray;
};

export const removeNodesAndUndoLastAction = ({
  formid,
  qf,
  nodeids,
  undoLastActionsRescursively,
}) => {
  // removing nodesorder

  qf.formstate[formid].nodesorder = _.difference(
    qf.formstate[formid].nodesorder,
    nodeids
  );
  // removing nodestate
  nodeids.forEach((nodeid) => {
    if (!_.isEmpty(qf.formstate[formid].nodestate[nodeid])) {
      qf = undoLastActionsRescursively({
        qf: { ...qf },
        node: qf.formstate[formid].nodestate[nodeid],
      });

      if (qf.formstate[formid] && qf.formstate[formid].nodestate[nodeid])
        delete qf.formstate[formid].nodestate[nodeid];
    }
  });

  return qf;
};

export const getAllQuestionsUnderGroup = ({
  groupid,
  questiontable,
  operations,
  calculatedverticalid,
}) => {
  let questions = [];
  let questionids = [];
  let questionsInObject = {};
  //
  //
  //

  questiontable.forEach((question) => {
    if (question.groupid === groupid) {
      const { questionverticalid, operationverticalid } = question;

      // Check whether questionverticalid or operationverticalid are empty
      const isOperationIdEmpty = _.isEmpty(operationverticalid);
      const isVerticalIdEmpty = _.isEmpty(questionverticalid);

      // Initialize conditions for inclusion of question
      let includeQuestion = false;

      if (isOperationIdEmpty && isVerticalIdEmpty) {
        // If both are empty, include question as normal
        includeQuestion = true;
      } else if (isOperationIdEmpty) {
        // If operationverticalid is empty, proceed based on questionverticalid
        if (questionverticalid.includes(calculatedverticalid)) {
          includeQuestion = true;
        }
      } else {
        // If operationverticalid is not empty, check for matches in operations
        const operationIds = operations.map((operation) => operation.id);
        if (_.intersection(operationverticalid, operationIds).length > 0) {
          includeQuestion = true;
        }
      }

      if (includeQuestion) {
        questions.push(question);
        questionids.push(question.id);
        questionsInObject[question.id] = { ...question };
      }
    }
  });

  return { questionids: questionids.sort(), questions, questionsInObject };
};

export const getAvailableGroupIdsAndGroupTableInObjectForm = ({
  groupids,
  groupstable,
}) => {
  let availableGroupIds = [];
  let groupTableInObjectForm = {};

  if (!_.isEmpty(groupids)) {
    groupids.forEach((groupid) => {
      if (groupstable[groupid]) {
        availableGroupIds.push(groupid);
        groupTableInObjectForm[groupid] = { ...groupstable[groupid] };
      }
    });
  }

  return { availableGroupIds, groupTableInObjectForm };
};

export const getAvailableFormIdsAndFormTableInObjectForm = ({
  formids,
  formstable,
}) => {
  let availableFormIds = [];
  let formTableInObjectForm = {};

  if (!_.isEmpty(formids)) {
    formids.forEach((formid) => {
      if (formstable[formid]) {
        availableFormIds.push(formid);
        formTableInObjectForm[formid] = { ...formstable[formid] };
      }
    });
  }

  return { availableFormIds, formTableInObjectForm };
};

const getQuestion = (id, questiontable) => {
  let questions = questiontable.filter((question) => question.id === id);

  if (!_.isEmpty(questions)) {
    return questions[0];
  }
  return null;
};

export const getAvailableQuestionIdsAndQuestionTableInObjectForm = ({
  questionids,
  questiontable,
}) => {
  let availableQuestionIds = [];
  let questionTableInObjectForm = {};

  if (!_.isEmpty(questionids)) {
    questionids.forEach((questionid) => {
      let question = getQuestion(questionid, questiontable);
      if (question) {
        availableQuestionIds.push(questionid);
        questionTableInObjectForm[questionid] = question;
      }
    });
  }

  return { availableQuestionIds, questionTableInObjectForm };
};

export const updateGroupStateAsPerGroupsOrder = ({
  formstate,
  groupTableInObjectForm,
  formid,
  // this question table is in array form
  questiontable,
  calculatedverticalid,
  operations,
  triagedata
}) => {
  let questionInObjectForAllGroups = {}; // as it will be required in next step after loop

  // console.log(
  //   "groupTableInObjectForm",
  //   JSON.parse(JSON.stringify(groupTableInObjectForm))
  // );

  // console.log(
  //   "questionsInObject questiontable",
  //   JSON.parse(JSON.stringify(questiontable))
  // );

  // console.log(
  //   "questionsInObject Form state at start of update formstate",
  //   JSON.parse(JSON.stringify(formstate))
  // );

  formstate.groupsorder.forEach((groupid) => {
    const ifGroupStateAlreadyThere = formstate.groupstate[groupid]
      ? true
      : false;

    if (!ifGroupStateAlreadyThere) {
      // groupstate is having all the group's properties
      formstate.groupstate[groupid] = {
        ...groupTableInObjectForm[groupid],
        formid,
      };
      // questionsorder in groupstate

      let { questionids, questionsInObject } = getAllQuestionsUnderGroup({
        groupid,
        questiontable,
        operations: operations || [],
        calculatedverticalid: calculatedverticalid || 0,
      });
      // console.log(
      //   "in the normal way questionids",
      //   JSON.parse(JSON.stringify(questionids))
      // );
      // console.log(
      //   "in the normal way questionsInObject",
      //   JSON.parse(JSON.stringify(questionsInObject))
      // );

     // go through add questions in triage and add it to the group
      if(triagedata?.addQuestions){
        let newQidsGroup = triagedata.addQuestions.filter(x => x.groupid == groupid);
        for(let newQids of newQidsGroup){
          if(newQids){
            let newUniqueQids = newQids.qid.filter(x => !questionids.includes(x))
            questionids.push(...newUniqueQids);
            newUniqueQids.forEach((qid) => {
              questionsInObject[qid] = questiontable.find(x => x.id ==  qid)
            })
          }
        }
      }
      formstate.groupstate[groupid].questionsorder = questionids;

      questionInObjectForAllGroups = {
        ...questionInObjectForAllGroups,
        ...questionsInObject,
      };
    }
  });

  // console.log(
  //   "questionsInObject Form state at middle of update formstate",
  //   JSON.parse(JSON.stringify(formstate))
  // );

  if (formstate.buildings) {
    formstate.buildings.map((building, buildingIndex) => {
      building.groupsorder.forEach((groupid) => {
        // questionsorder in groupstate
        const ifGroupStateAlreadyThere = formstate.buildings[buildingIndex]
          .groupstate[groupid]
          ? true
          : false;
        // console.log(
        //   "questionids ifGroupStateAlreadyThere ",
        //   ifGroupStateAlreadyThere
        // );

        //
        // console.log(
        //   "show me groupId ifGroupStateAlreadyThere",

        //   JSON.parse(JSON.stringify(groupTableInObjectForm[groupid]))
        // );

        // console.log(
        //   "show me questiontable ifGroupStateAlreadyThere",
        //   JSON.parse(JSON.stringify(questiontable))
        // );

        if (!ifGroupStateAlreadyThere) {
          formstate.buildings[buildingIndex].groupstate[groupid] = {
            ...groupTableInObjectForm[groupid],
            formid,
          };
          // this will set all questions in the group including the question orders
          const { questionids, questionsInObject } = getAllQuestionsUnderGroup({
            groupid,
            questiontable,
            operations: operations || [],
            calculatedverticalid: calculatedverticalid || 0,
          });

          formstate.buildings[buildingIndex].groupstate[ /// this works just need to find out why questionids is not set..
            groupid
          ].questionsorder = questionids;

          //
          // console.log(
          //   "in the new building way questionsInObject",
          //   questionsInObject
          // );

          questionInObjectForAllGroups = {
            ...questionInObjectForAllGroups,
            ...questionsInObject,
          };

          // console.log(
          //   "ifGroupStateAlreadyThere questionInObjectForAllGroups ",
          //   questionInObjectForAllGroups
          // );
        }
      });
    });
  }

  // console.log(
  //   "questionsInObject Form state at end of update formstate",
  //   JSON.parse(JSON.stringify(formstate))
  // );
  //

  return { formstate, questionInObjectForAllGroups };
};

const getLocationStateOrBuilding = (
  locationState,
  isBuilding,
  buildingIndex
) => {
  return isBuilding ? locationState.buildings[buildingIndex] : locationState;
};

// export const updateLocationStateAsPerLocationsOrder = ({
//   formstate,
//   groupstable,
//   formid,
//   calculatedverticalid,
//   operations,
//   questiontable,
//   FormProperties,
//   isBuilding = false,
//   buildingIndex = 0,
// }) => {
//   let newFormstate = { ...formstate };
//   const { locationsorder, type } = newFormstate;

//   locationsorder.forEach((locationid) => {
//     const currentLocationState = getLocationStateOrBuilding(
//       newFormstate.locationstate[locationid],
//       isBuilding,
//       buildingIndex
//     );
//     const isLocationStateExist = currentLocationState ? true : false;

//     if (!isLocationStateExist) {
//       const groupsOrder = getFilteredGroupsUnderForm({
//         formid,
//         groupstable,
//         calculatedverticalid,
//         operations,
//       })
//         .map((group) => group.id)
//         .sort();

//       let updatedState = updateGroupStateAsPerGroupsOrder({
//         formstate: {
//           groupsorder: groupsOrder,
//           groupstate: {},
//         },
//         groupTableInObjectForm: groupstable,
//         formid,
//         questiontable,
//       });

//       if (isBuilding) {
//         newFormstate.locationstate[locationid].buildings[buildingIndex] =
//           updatedState.formstate;
//       } else {
//         newFormstate.locationstate[locationid] = updatedState.formstate;
//       }

//       let { questionInObjectForAllGroups } = updatedState;

//       newFormstate = FormProperties({ formtype: type }).updateNodesOrder({
//         formstate: { ...newFormstate },
//       });
// // need update here for building
//       newFormstate = FormProperties({
//         formtype: type,
//       }).updateNodeStateUsingNodesOrder({
//         formstate: { ...newFormstate },
//         formid,
//         formtype: type,
//         questionTableInObjectForm: questionInObjectForAllGroups,
//       });
//     }
//   });

//   return newFormstate;
// };

export const updateLocationStateAsPerLocationsOrder = ({
  formstate,
  groupstable,
  formid,
  calculatedverticalid,
  operations,
  // this question table is in array form
  questiontable,
  FormProperties,
}) => {
  let newFormstate = { ...formstate };
  const { locationsorder, type } = newFormstate;
  //
  //
  //
  //
  //

  locationsorder.forEach((locationid) => {
    let isLocationStateExist = newFormstate.locationstate[locationid]
      ? true
      : false;

    if (!isLocationStateExist) {
      newFormstate.locationstate[locationid] = {
        groupsorder: getFilteredGroupsUnderForm({
          formid,
          groupstable,
          calculatedverticalid,
          operations,
        })
          .map((group) => group.id)
          .sort(),

        groupstate: {},

        buildings: [
          {
            groupsorder: [],
            groupstate: {},
          },
        ],
      };

      // Initialize building templates from first existing location
      if (locationsorder.length > 1) {
        const firstLocationId = locationsorder.find(id => id !== locationid && newFormstate.locationstate[id]);
        if (firstLocationId && newFormstate.locationstate[firstLocationId].buildingIntialState) {
          newFormstate.locationstate[locationid].buildingIntialState =
            _.cloneDeep(newFormstate.locationstate[firstLocationId].buildingIntialState);
        }
        if (firstLocationId && newFormstate.locationstate[firstLocationId].buildingFirstQuestion) {
          newFormstate.locationstate[locationid].buildingFirstQuestion =
            _.cloneDeep(newFormstate.locationstate[firstLocationId].buildingFirstQuestion);
        }
      }

      let formstateAndQuestionTableInObject = updateGroupStateAsPerGroupsOrder({
        formstate: { ...newFormstate.locationstate[locationid] },
        groupTableInObjectForm: groupstable,
        formid,
        questiontable,
        calculatedverticalid
      });
      //
      // console.log(
      //   "location formstateAndQuestionTableInObject",
      //   JSON.parse(JSON.stringify(formstateAndQuestionTableInObject))
      // );
      // console.log(
      //   "location newFormstate",
      //   JSON.parse(JSON.stringify(newFormstate))
      // );
      // //
      //
      newFormstate.locationstate[locationid] =
        formstateAndQuestionTableInObject.formstate;
      let { questionInObjectForAllGroups } = formstateAndQuestionTableInObject;

      newFormstate = FormProperties({ formtype: type }).updateNodesOrder({
        formstate: { ...newFormstate },
      });

      newFormstate = FormProperties({
        formtype: type,
      }).updateNodeStateUsingNodesOrder({
        formstate: { ...newFormstate },
        formid,
        formtype: type,
        questionTableInObjectForm: questionInObjectForAllGroups,
      });
    }
  });

  return newFormstate;
};

export const updateBuildingAsPerBuildingsOrder = ({
  formstate,
  groupstable,
  formid,
  calculatedverticalid,
  operations,
  // this question table is in array form
  questiontable,
  FormProperties,
  buildingIndex,
  locationid,
  buildingIntialState,
}) => {
  let newFormstate = { ...formstate };
  const { locationsorder, type } = newFormstate;
  //
  //
  //
  //
  //
  //

  // locationsorder.forEach((locationid) => {
  let isBuildingStateExist = newFormstate.locationstate[locationid].buildings[
    buildingIndex
  ]
    ? true
    : false;

  // if (!isBuildingStateExist) {
  //
  if (buildingIndex >= 0) {
    let tempBuilding = _.cloneDeep(buildingIntialState);
    delete tempBuilding.answer;
    newFormstate.locationstate[locationid].buildings[buildingIndex] = {
      groupsorder: ["e_100_50"],
      groupstate: {
        e_100_50: tempBuilding,
      },
    };
  } else {
    newFormstate.locationstate[locationid].buildings[buildingIndex] = {
      groupsorder: ["e_100_50"],
      groupstate: {},
    };
  }

  let formstateAndQuestionTableInObject = updateGroupStateAsPerGroupsOrder({
    formstate: { ...newFormstate.locationstate[locationid] },
    groupTableInObjectForm: groupstable,
    formid,
    questiontable,
  });

  newFormstate.locationstate[locationid] =
    formstateAndQuestionTableInObject.formstate;
  let { questionInObjectForAllGroups } = formstateAndQuestionTableInObject;

  newFormstate = FormProperties({ formtype: type }).updateNodesOrder({
    formstate: { ...newFormstate },
  });
  // console.log(
  //   "questionInObjectForAllGroups add building",
  //   JSON.parse(JSON.stringify(questionInObjectForAllGroups))
  // );
  newFormstate = FormProperties({
    formtype: type,
  }).updateNodeStateUsingNodesOrder({
    formstate: { ...newFormstate },
    formid,
    formtype: type,
    questionTableInObjectForm: questionInObjectForAllGroups,
  });
  // }
  // });

  return newFormstate;
};

const getAllGroupsUnderForm = ({ formid, groupstable }) => {
  let groups = [];
  for (let groupid in groupstable) {
    if (groupstable[groupid].formid === formid) {
      groups.push(groupstable[groupid]);
    }
  }

  return groups;
};

export const intersection = (array1, array2) => {
  if (_.isEmpty(underscore.intersection(array1, array2))) return false;
  return true;
};

export const getFilteredGroupsUnderForm = ({
  formid,
  calculatedverticalid,
  operations,
  groupstable,
  triagedata
}) => {
  let groups = getAllGroupsUnderForm({ formid, groupstable });

  //Step 1 get all groups which does not have any operationids and verticalids
  let groupsinStep1 = [];
  let groupsinStep2 = [];
  let groupsinStep3 = [];

  groups.forEach((group) => {
    if (_.isEmpty(group.verticalids) && _.isEmpty(group.operationids)) {
      groupsinStep1.push(group);
    } else {
      //Step 2 get all the groups which includes calculatedverticalid in vericalids

      let operationids = group.operationids;

      if (!_.isEmpty(operationids)) {
        if (
          calculatedverticalid == operations[0]?.vertical?.id &&
          intersection(
            operationids,
            operations.map((operation) => operation.id)
          )
        ) {
          groupsinStep2.push(group);
        }
      }
      //Step 3 get all the groups which includes operations[0].id, operations[1].id and so on in operationids

      let verticalids = group.verticalids;

      if (!_.isEmpty(verticalids)) {
        if (intersection(verticalids, [calculatedverticalid])) {
          groupsinStep3.push(group);
        }
      }
    }
    // ADD GROUPS BASED ON TRIAGE LOGIC
    if(formid == 'a' && triagedata){
        // console.log('FORM A GROUP ', group)
        // console.log("triagedata: ", triagedata);
        if(Array.isArray(triagedata.addGroups) && triagedata.addGroups.includes(group.id)){
          groupsinStep3.push(group)
        }

    }
  });

  //Step 4 merge all the groups from previous steps and have unique out of that

  let finalGroups = [
    ...new Set([...groupsinStep1, ...groupsinStep2, ...groupsinStep3]),
  ].sort();
  return finalGroups;
};

//#region action Type: addQuestionsToOtherGroup Doing and UnDoing
export const addQuestionsToOtherGroupFunc = ({
  actionObject,
  formid,
  node,
  questiontable,
  locationid,
  qf,
  doc,
  getAvailableQuestionIdsAndQuestionTableInObjectForm,
  convertQuestionIdsToNodeIdsAsPerForm,
  FormProperties,
  getOperationListProspectDoc,
  buildingid,
}) => {
  let newActionObject = { ...actionObject };

  let formidToAddQuestion = formid;
  if (actionObject.formid) formidToAddQuestion = actionObject.formid;
  let questionids = actionObject.questionids;
  let groupid = actionObject.groupid;

  let newNodeFormType = qf.formstate[formidToAddQuestion].type;

  // change the node groupid and formid
  let newNode = {
    ...node,
    formid: formidToAddQuestion,
    groupid,
    formtype: newNodeFormType,
  };

  if (_.isEmpty(qf.formstate[formidToAddQuestion])) {
    newActionObject = {};
  } else {
    // refine the payload as per the question available in the table
    let { availableQuestionIds, questionTableInObjectForm } =
      getAvailableQuestionIdsAndQuestionTableInObjectForm({
        questionids,
        questiontable: questiontable,
      });

    let nodeids = convertQuestionIdsToNodeIdsAsPerForm({
      questionids: availableQuestionIds,
      formtype: newNodeFormType,
      locationid,
      buildingid,
    });
    qf.formstate[formidToAddQuestion] = FormProperties({
      formtype: newNodeFormType,
    }).addQuestions({
      questionids: availableQuestionIds,
      nodeids,
      formstate: { ...qf.formstate[formidToAddQuestion] },
      node: newNode,
      questionTableInObjectForm,
      questiontable,
      operations: getOperationListProspectDoc(doc),
    });

    // change the payload in the demanded actions as only the valid questionids should be there

    newActionObject = {
      ...actionObject,
      questionids: availableQuestionIds,
    };
  }

  return { qf, newActionObject };
};

export const undoAddQuestionsToOtherGroupFunc = ({
  lastActionObject,
  formid,
  qf,
  node,
  locationid,
  convertQuestionIdsToNodeIdsAsPerForm,
  FormProperties,
  buildingid,
}) => {
  let formidToAddQuestion = formid;
  if (lastActionObject.formid) formidToAddQuestion = lastActionObject.formid;
  let questionids = lastActionObject.questionids;
  let groupid = lastActionObject.groupid;

  let newNodeFormType = qf.formstate[formidToAddQuestion].type;
  // change the node groupid and formid
  let newNode = {
    ...node,
    formid: formidToAddQuestion,
    groupid,
    formtype: newNodeFormType,
  };

  let nodeids = convertQuestionIdsToNodeIdsAsPerForm({
    questionids,
    formtype: newNodeFormType,
    locationid,
    buildingid,
  });
  if (buildingid === "") {
    qf = FormProperties({ formtype: newNodeFormType }).removeQuestions({
      questionids,
      nodeids,
      node: newNode,
      qf: { ...qf },
    });
  }

  return qf;
};
//#endregion

//#region Operation Form

const questionsFromVerticalId = ({ calculatedverticalid, questiontable }) => {
  let interestedQuestions = [];
  questiontable.forEach((question) => {
    if (!_.isEmpty(question.verticalids)) {
      if (intersection([calculatedverticalid], question.verticalids))
        interestedQuestions.push(question);
    }
  });

  return interestedQuestions;
};

export const createOperationNodeId = ({ index, questionid }) => {
  return `operation_${index}_${questionid}`;
};

const convertQuestionsToOperationQuestionIds = ({ questions, index }) => {
  let questionids = questions.map((q) => q.id);

  return questionids.map((questionid) =>
    createOperationNodeId({ index, questionid })
  );
};

export const createOperationGroupId = ({ operationNumber }) => {
  return `0_operation_${operationNumber}`;
};

export const updateGroupsOrderAndStateAsPerOperations = ({
  formstate,
  // these operations are array of objects
  operations,
  calculatedverticalid,
  // array of objects
  questiontable,
}) => {
  // let operationids = operations.map((operation) => operation.id);

  let operationgroupids = [];
  let operationgroupstates = {};

  let questionsFromVerticalIdFromQuestionTable = questionsFromVerticalId({
    calculatedverticalid,
    questiontable,
  });

  if (!_.isEmpty(questionsFromVerticalIdFromQuestionTable)) {
    operations.forEach((operation, index) => {
      let groupid = createOperationGroupId({ operationNumber: index + 1 });
      console.log("new groupid ", groupid);
      operationgroupids.push(groupid);
      operationgroupstates[groupid] = {
        dynamic: true,

        id: groupid,
        formid: formstate.id,
        text: operation.name,
        index: index + 1,
        operationid: operation.id,
        description: operation.description,
        questionsorder: convertQuestionsToOperationQuestionIds({
          index: index + 1,

          questions: questionsFromVerticalIdFromQuestionTable,
        }).sort(),
      };
    });
  }

  formstate.groupsorder = [
    ...formstate.groupsorder,
    ...operationgroupids,
  ].sort();
  formstate.groupstate = { ...formstate.groupstate, ...operationgroupstates };
  return formstate;
};

const demistifyOperationId = ({ nodeid }) => {
  let nodeidarray = nodeid.split("_");

  return {
    index: Number(nodeidarray[1]),
    questionid: nodeidarray[2],
  };
};

export const updateOperationNodesOrderAndNodeStateAsPerGroups = ({
  formstate,
  questiontable,
  operations,
}) => {
  let nodesOrder = [];
  formstate.groupsorder.forEach((groupid) => {
    nodesOrder = [
      ...nodesOrder,
      ...formstate.groupstate[groupid].questionsorder,
    ];
  });

  formstate.nodesorder = [...nodesOrder];

  formstate.nodesorder.forEach((nodeid) => {
    //console.log("This is nodeid", nodeid);
  });

  const timeCreated = new Date().getTime();
  formstate.nodesorder.forEach((nodeid) => {
    if (_.isEmpty(formstate.nodestate[nodeid])) {
      if (getQuestion(nodeid, questiontable) === null) {
        let { index, questionid } = demistifyOperationId({ nodeid });

        let newNode = {
          formtype: formstate.type,
          questionid,
          index,
          formid: formstate.id,
          ...getQuestion(questionid, questiontable),
          time: timeCreated,
          operation: operations[index - 1],
          groupid: createOperationGroupId({ operationNumber: index }),
          id: createOperationNodeId({ index, questionid }),
        };

        // TODO: update for default answer
        if (newNode.logic.defaultanswer)
          newNode.answer = newNode.logic.defaultanswer;

        delete newNode._id;
        delete newNode.__v;
        console.log(`new node operation ${newNode}`);
        formstate.nodestate[nodeid] = newNode;
      }
    }
  });

  return formstate;
};

//#endregion

//This function is also used in Backend AuthService in commons/frontEndFunctions
export const generateClientDetailsFromFormstateAndPermanentCodeDetails = ({
  permanentcodedetails,
  formstate,
}) => {
  let clientdetailstosend = {};

  if (permanentcodedetails) {
    try {
      for (let permanentcode in permanentcodedetails) {
        let { formid, id } = permanentcodedetails[permanentcode];

        clientdetailstosend[permanentcode] = formstate[formid].nodestate[id]
          ? formstate[formid].nodestate[id].answer
            ? formstate[formid].nodestate[id].answer
            : ""
          : "";
      }
    } catch (er) {
      return {};
    }
  }

  return clientdetailstosend;
};

export const addressParts = {
  country: "country",
  postalcode: "postalcode",
  streetNumber: "streetNumber",
  street: "street",
  province: "province",
  town: "town",
  unitNumber: "unitNumber",
  street1: "street1",
};

export const getAddressInFormattedForm = ({ node }) => {
  try {
    if (node.type === "address") {
      return `${
        node.answer[addressParts.streetNumber]
          ? node.answer[addressParts.streetNumber]
          : ""
      } ${
        node.answer[addressParts.street]
          ? node.answer[addressParts.street] + ","
          : ""
      } ${
        node.answer[addressParts.town]
          ? node.answer[addressParts.town] + ","
          : ""
      } ${
        node.answer[addressParts.province]
          ? node.answer[addressParts.province] + ","
          : ""
      } ${
        node.answer[addressParts.country]
          ? node.answer[addressParts.country] + "."
          : ""
      } ${
        node.answer[addressParts.postalcode]
          ? node.answer[addressParts.postalcode]
          : ""
      } ${
        node.answer[addressParts.unitNumber]
          ? node.answer[addressParts.unitNumber]
          : ""
      } 
    
      
      `;
    }
    return null;
  } catch (e) {
    return null;
  }
};

export const getShortAddressInFormattedForm = ({ node }) => {
  try {
    if (node.type === "address") {
      return `${
        node.answer[addressParts.streetNumber]
          ? node.answer[addressParts.streetNumber]
          : ""
      } ${
        node.answer[addressParts.street]
          ? node.answer[addressParts.street] + ","
          : ""
      } ${
        node.answer[addressParts.town]
          ? node.answer[addressParts.town] + ","
          : ""
      } ${
        node.answer[addressParts.postalcode]
          ? node.answer[addressParts.postalcode]
          : ""
      }`;
    }
    return null;
  } catch (e) {
    return null;
  }
};

export const createQuestionSection = ({}) => {};
